import { useEffect, useState } from "react";

import {
  getPresupuestos,
  createPresupuesto,
  updatePresupuesto,
  deletePresupuesto,
} from "../services/presupuestosService";

export const usePresupuestos = () => {
  const [presupuestos, setPresupuestos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // =========================
  // CARGAR TODOS
  // =========================
  const cargarPresupuestos = async () => {
    try {
      setLoading(true);
      setError(null);

      const data = await getPresupuestos();

      setPresupuestos(data);
    } catch (err) {
      console.error(
        "Error cargando presupuestos:",
        err
      );

      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // =========================
  // CREAR
  // =========================
  const crearPresupuesto = async (
    nuevoPresupuesto
  ) => {
    try {
      await createPresupuesto(
        nuevoPresupuesto
      );

      await cargarPresupuestos();
    } catch (err) {
      console.error(
        "Error creando presupuesto:",
        err
      );

      throw err;
    }
  };

  // =========================
  // EDITAR
  // =========================
  const editarPresupuesto = async (
    id_presupuesto,
    presupuestoActualizado
  ) => {
    try {
      await updatePresupuesto(
        id_presupuesto,
        presupuestoActualizado
      );

      await cargarPresupuestos();
    } catch (err) {
      console.error(
        "Error actualizando presupuesto:",
        err
      );

      throw err;
    }
  };

  // =========================
  // ELIMINAR
  // =========================
  const eliminarPresupuesto = async (
    id_presupuesto
  ) => {
    try {
      await deletePresupuesto(
        id_presupuesto
      );

      await cargarPresupuestos();
    } catch (err) {
      console.error(
        "Error eliminando presupuesto:",
        err
      );

      throw err;
    }
  };

  // =========================
  // INIT
  // =========================
  useEffect(() => {
    cargarPresupuestos();
  }, []);

  return {
    presupuestos,
    loading,
    error,

    cargarPresupuestos,

    crearPresupuesto,
    editarPresupuesto,
    eliminarPresupuesto,
  };
};